/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsuredResponseDto } from './InsuredResponseDto';
import {
    InsuredResponseDtoFromJSON,
    InsuredResponseDtoFromJSONTyped,
    InsuredResponseDtoToJSON,
    InsuredResponseDtoToJSONTyped,
} from './InsuredResponseDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface InsuredPaginationResponseDto
 */
export interface InsuredPaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof InsuredPaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<InsuredResponseDto>}
     * @memberof InsuredPaginationResponseDto
     */
    items: Array<InsuredResponseDto>;
}

/**
 * Check if a given object implements the InsuredPaginationResponseDto interface.
 */
export function instanceOfInsuredPaginationResponseDto(value: object): value is InsuredPaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function InsuredPaginationResponseDtoFromJSON(json: any): InsuredPaginationResponseDto {
    return InsuredPaginationResponseDtoFromJSONTyped(json, false);
}

export function InsuredPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsuredPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(InsuredResponseDtoFromJSON)),
    };
}

export function InsuredPaginationResponseDtoToJSON(json: any): InsuredPaginationResponseDto {
    return InsuredPaginationResponseDtoToJSONTyped(json, false);
}

export function InsuredPaginationResponseDtoToJSONTyped(value?: InsuredPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(InsuredResponseDtoToJSON)),
    };
}

